import React, { useEffect, useState } from 'react'

import { ReactComponent as ArrowRight } from '../../assets/icons/icon_arrow_right.svg';
import { ReactComponent as CloseIcon } from '../../assets/icons/icon_plus.svg';
import { ReactComponent as StarIcon } from '../../assets/icons/icon_star_white.svg';
import { ReactComponent as ArrowLeft } from '../../assets/icons/icon_arrow_left.svg';

interface Props {
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    children?: any;
    /**
     * @description The button will turn grey and be unclickable.
     */
    disabled?: boolean;
    /**
     * @example Colors: black
     */
    modifiers?: string | string[];
    arrow?: boolean;
    close?: boolean;
    indicatorText?: string;
    backArrow?: boolean;
    star?: boolean;
}

const HanButton: React.FC<Props> = ({ children, onClick, disabled, modifiers, arrow, close, indicatorText, star, backArrow }) => {
    const baseClassName = "han-button";
    const [className, setClassName] = useState<string>(baseClassName);

    const Icon = arrow ? ArrowRight : close ? CloseIcon : undefined;
    const LeftIcon = backArrow ? ArrowLeft : star ? StarIcon : undefined;

    useEffect(() => {
        if(modifiers) {
            let classNameString = baseClassName;

            if(Array.isArray(modifiers)) {
                modifiers.forEach(modifier => {
                    classNameString += ` ${baseClassName}--${modifier}`;
                })
            } else {
                classNameString += ` ${baseClassName}--${modifiers}`;
            }
            
            setClassName(classNameString);
        }
    }, [modifiers])
    
    return (
        <button onClick={onClick} disabled={disabled} className={className}>

            { LeftIcon && <LeftIcon className='han-button__icon--star'/> }
            
            { children &&
                <span className={'han-button__text'}>
                    { children }
                </span>
            }

            { indicatorText &&
                <span className={'han-button__indicator'}>
                    { indicatorText }
                </span>
            }

            { Icon && <Icon className={'han-button__icon'}/> }
        </button>
    )
}

export default HanButton;
